import React, { useState, useEffect } from "react";
import { Form, Input, Button, Divider, message, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import * as api from "../../api";
import Layout from "../../components/admin/layout";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 8 },
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 8 },
};

let initImage = {
  qualification_image_1_th: undefined,
  qualification_image_1_en: undefined,
  qualification_image_2_th: undefined,
  qualification_image_2_en: undefined,
  qualification_image_3_th: undefined,
  qualification_image_3_en: undefined,
  qualification_image_4_th: undefined,
  qualification_image_4_en: undefined,
  qualification_image_5_th: undefined,
  qualification_image_5_en: undefined,
};

const Qualification = () => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState([]);
  const [image, setImage] = useState(initImage);

  useEffect(() => {
    init();
  }, []);

  async function init() {
    try {
      const {
        data: { data },
      } = await api.getContent();
      setContent(data.content);
      setImage({
        qualification_image_1_th: data.content["qualification_image_1_th"],
        qualification_image_1_en: data.content["qualification_image_1_en"],
        qualification_image_2_th: data.content["qualification_image_2_th"],
        qualification_image_2_en: data.content["qualification_image_2_en"],
        qualification_image_3_th: data.content["qualification_image_3_th"],
        qualification_image_3_en: data.content["qualification_image_3_en"],
        qualification_image_4_th: data.content["qualification_image_4_th"],
        qualification_image_4_en: data.content["qualification_image_4_en"],
        qualification_image_5_th: data.content["qualification_image_5_th"],
        qualification_image_5_en: data.content["qualification_image_5_en"],
      });
      form.setFieldsValue(data.content);
    } catch (error) {
      console.log("Error while call init()", error);
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    return isJpgOrPng;
  }

  function handleChange(info, key) {
    if (info.file.status === "done") {
      setImage((prev) => ({ ...prev, [key]: info.file.response.data.url }));
    }
  }

  const onFinish = (values) => {
    update({
      ...values,
      ...image
    })
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  async function update(data) {
    try {
      setIsSubmitting(true)
      const res = await api.updateContent(data)
      message.success('บันทึกเรียบร้อยแล้ว');
    } catch (error) {
      message.success('เกิดข้อผิดพลา ดกรุณาลองใหม่อีกครั้ง');
      console.log("Error while call error()", error);
    }
    setIsSubmitting(false)
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Layout>
      <Form
        {...layout}
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item label="หัวข้อ (ไทย)" name="qualification_title_1_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="qualification_title_1_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="qualification_description_1_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="qualification_description_1_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป (ไทย)" name="qualification_image_1_th">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_1_th")}
          >
            {image.qualification_image_1_th ? (
              <img
                src={image.qualification_image_1_th}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="รูป (อังกฤษ)" name="qualification_image_1_en">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_1_en")}
          >
            {image.qualification_image_1_en ? (
              <img
                src={image.qualification_image_1_en}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />
        <Form.Item label="หัวข้อ (ไทย)" name="qualification_title_2_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="qualification_title_2_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="qualification_description_2_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="qualification_description_2_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป (ไทย)" name="qualification_image_2_th">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_2_th")}
          >
            {image.qualification_image_2_th ? (
              <img
                src={image.qualification_image_2_th}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="รูป (อังกฤษ)" name="qualification_image_2_en">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_2_en")}
          >
            {image.qualification_image_2_en ? (
              <img
                src={image.qualification_image_2_en}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />

        <Form.Item label="หัวข้อ (ไทย)" name="qualification_title_3_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="qualification_title_3_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="qualification_description_3_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="qualification_description_3_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป (ไทย)" name="qualification_image_3_th">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_3_th")}
          >
            {image.qualification_image_3_th ? (
              <img
                src={image.qualification_image_3_th}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="รูป (อังกฤษ)" name="qualification_image_3_en">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_3_en")}
          >
            {image.qualification_image_3_en ? (
              <img
                src={image.qualification_image_3_en}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />

        <Form.Item label="หัวข้อ (ไทย)" name="qualification_title_4_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="qualification_title_4_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="qualification_description_4_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="qualification_description_4_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป (ไทย)" name="qualification_image_4_th">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_4_th")}
          >
            {image.qualification_image_4_th ? (
              <img
                src={image.qualification_image_4_th}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="รูป (อังกฤษ)" name="qualification_image_4_en">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_4_en")}
          >
            {image.qualification_image_4_en ? (
              <img
                src={image.qualification_image_4_en}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />

        <Form.Item label="หัวข้อ (ไทย)" name="qualification_title_5_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="qualification_title_5_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="qualification_description_5_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="qualification_description_5_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป (ไทย)" name="qualification_image_5_th">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_5_th")}
          >
            {image.qualification_image_5_th ? (
              <img
                src={image.qualification_image_5_th}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="รูป (อังกฤษ)" name="qualification_image_5_en">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "qualification_image_5_en")}
          >
            {image.qualification_image_5_en ? (
              <img
                src={image.qualification_image_5_en}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button htmlType="button">ยกเลิก</Button>
          <Button type="primary" htmlType="submit">
            บันทึก
          </Button>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default Qualification;
